import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Modal,
  Typography,
} from '@mui/material';

import { STRINGS } from '../../../constants';
import { CITYSPRINT_BACK_TO_PARCEL_CONFIRM } from '../constants';

export const CitysprintLoseQuoteConfirmModal = ({
  open,
  onConfirm,
  onCancel,
}) => (
  <Modal
    open={open}
    onClose={onCancel}
    aria-labelledby='citysprint-lose-quote-title'
    aria-describedby='citysprint-lose-quote-description'
  >
    <Card
      variant='elevation'
      sx={{
        position: 'relative',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        maxWidth: '500px',
        width: '100%',
      }}
      role='dialog'
    >
      <CardHeader
        title={
          <Box display='flex' id='citysprint-lose-quote-title'>
            <Typography variant='h6' gutterBottom>
              {CITYSPRINT_BACK_TO_PARCEL_CONFIRM.TITLE}
            </Typography>
          </Box>
        }
      />
      <CardContent id='citysprint-lose-quote-description'>
        <Typography variant='body1' gutterBottom>
          {CITYSPRINT_BACK_TO_PARCEL_CONFIRM.BODY}
        </Typography>
      </CardContent>
      <CardActions
        sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, p: 2 }}
      >
        <Button variant='outlined' color='primary' onClick={onCancel}>
          {STRINGS.CANCEL}
        </Button>
        <Button variant='contained' color='primary' onClick={onConfirm}>
          {CITYSPRINT_BACK_TO_PARCEL_CONFIRM.CONFIRM_BUTTON}
        </Button>
      </CardActions>
    </Card>
  </Modal>
);
